import { Controller } from "react-hook-form";
import { FormHelperText, FormLabel, TextField } from "@material-ui/core";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";

import useStyles from "../styles";

import { AutocompleteProps } from "./autocomplete.props";

export const Autocomplete = (props: AutocompleteProps) => {
  const classes = useStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;

  const {
    limitTags = -1,
    optionLabel = (option: { label: string }) => option.label,
    placeholder = "",
    required = false,
  } = props;

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <label className={classes.fieldWrapper}>
          <FormLabel
            className={classes.label}
            component="span"
            error={hasError}
            required={required}
          >
            {props.label}
          </FormLabel>
          <MuiAutocomplete
            {...renderProps.field}
            getOptionLabel={optionLabel}
            getOptionSelected={props.optionSelected}
            id={props.name}
            limitTags={limitTags}
            multiple={props.multiple}
            // MuiAutocomplete crashes if onChange() is not wrapped like this
            onChange={(_, data) => renderProps.field.onChange(data)}
            options={props.options}
            renderInput={(params) => (
              <TextField
                {...params}
                error={hasError}
                fullWidth={props.fullWidth}
                placeholder={
                  (props.multiple && !renderProps.field.value.length) ||
                  (!props.multiple && renderProps.field.value !== "")
                    ? placeholder
                    : ""
                }
                variant="outlined"
              />
            )}
          />
          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </label>
      )}
    />
  );
};
